<script setup lang="ts">
useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: 'Home', item: '/' },
      { name: 'GDPR & SCCs', item: '/gdpr' }
    ]
  })
])

useHead({
  title: 'Geniuslink, GDPR, and Privacy Shield',
  meta: [{ name: 'description', content: 'How we help keep you GDPR compliant' }]
})
</script>

<template>
  <div class="container">
    <section class="row">
      <div class="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2">
        <ol class="breadcrumb">
          <li><NuxtLink to="/">Home</NuxtLink></li>
          <li class="active">GDPR &amp; SCCs</li>
        </ol>

        <h1>GDPR & SCCs</h1>
        <br>
        <div class="row">
          <div class="col-md-4">
            <img src="/img/feature-block-shield.svg" style="margin-left: -25px" alt="GDPR compliance">
          </div>
          <div class="col-md-8">
            <p style="padding: 20px 0 0 0">
              We strongly believe in data privacy and have worked with top legal minds to address how Geniuslink, its links, and clients can be good internet citizens and best comply with the relevant legislation (GDPR, CCPA, ePrivacy, etc.). Further, Geniuslink has historically participated in Safe Harbor and Privacy Shield and now uses the SCCs framework to ensure good data privacy and security.
            </p>
          </div>
        </div>

        <h2 class="text-h3">How we help you comply with GDPR</h2>
        <ul>
          <li>We store no personally identifiable information, including IP addresses, from clicks on your links.</li>
          <li>For your convenience, if you add retargeting scripts/pixels to your links, we will not serve them to EU visitors. You may change this behavior in your account settings.</li>
        </ul>

        <h2 class="text-h3">How Geniuslink complies with GDPR</h2>
        <ul>
          <li>For clicks on geni.us links: We store no personally identifiable information, including IP addresses.</li>
          <li>For Geniuslink website visits: We ask for consent from EU visitors before serving non-essential cookies used in marketing.</li>
          <li>For access to the Geniuslink client dashboard and supporting services: In accordance with GDPR, we serve essential, identifying cookies to our clients that allow them to use important functions such as login, onboarding, and support chat.</li>
        </ul>

        <h2 class="text-h3">Our stance on privacy</h2>
        <p>We are big fans of what GDPR is trying to do, and believe that your personal information should belong to you. We also believe companies should respect your privacy when you give them consent to collect any identifiable information.</p>

        <p>For some in-depth information about GDPR and how it relates to Geniuslink, see our blog post, <a href="https://geniuslink.com/blog/gdpr-geniuslink-you/"><em>GDPR, Geniuslink & You</em></a>. Specific information about how we approach data collection and GDPR can be found in the <NuxtLink to="/terms">Geniuslink Terms of Service</NuxtLink>.</p>
        <p>See our <NuxtLink to="/terms/#GDPR">General Data Protection Regulation Data Processing Addendum</NuxtLink> for Genius Link, where our Joint Controller relationship with our clients is defined. Our focus on Privacy is spelled out in our <a href="https://geniuslink.com/privacy">Privacy Policy.</a> Our Standard Contractual Clauses for Controllers addendum can be found <NuxtLink to="/terms/#SCCS">here</NuxtLink>.</p>
      </div>
    </section>
  </div>
</template>
